/* eslint-disable */
import { Button, Chip, Grid, IconButton, Snackbar, Tooltip, Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CloseIcon from '@material-ui/icons/Close';
import DomainIcon from '@material-ui/icons/Domain';
import ErrorIcon from '@material-ui/icons/Error';
import GradientIcon from '@material-ui/icons/Gradient';
import LinkIcon from '@material-ui/icons/Link';
import ModeCommentIcon from '@material-ui/icons/ModeComment';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import UndoIcon from '@material-ui/icons/Undo';
import VisibilityIcon from '@material-ui/icons/Visibility';
import WarningIcon from '@material-ui/icons/Warning';
import WatchIcon from '@material-ui/icons/Watch';
import WavesIcon from '@material-ui/icons/Waves';
import cn from 'classnames';
import size from 'lodash/size';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { ORDER_API_DATE_FORMAT } from '../../Constants/Order/Order.constants';
import withServices from '../../Contexts/Services/WithServices.context';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import {
  UI_DOCKET_MODAL_CANCEL_DELETE_NOTE,
  UI_DOCKET_MODAL_DELETE_NOTE_ATTEMPT,
  UI_DOCKET_MODAL_SHOW_DELETE_CONFIRM,
  UI_DOCKET_MODAL_TAB_CHANGE,
} from '../../State/Store/UI/UI.types';
import userProfileCurrentSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import dateOnly from '../../Support/DateTime/DateOnly/DateTimeDateOnly.support';
import envGet from '../../Support/Env/Get/EnvGet.support';
import generateHash from '../../Support/Generators/GenerateHash/GeneratorsGenerateHash.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Disclaimer from '../Disclaimer/Disclaimer.component';
import Icons from '../Icons/Icons.component';
import Modal from '../Modal/Modal.component';
import Spinner from '../Spinner/Spinner.component';
import DeliveryDocketPropTypes from './DeliveryDocket.component.props';
import deliveryDocketStyles from './DeliveryDocket.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

const REACT_APP_BORAL_ABRIDGED_CONDITIONS_URL = envGet({ key: `REACT_APP_BORAL_ABRIDGED_CONDITIONS_URL` });

/**
 * DeliveryDocket
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const DeliveryDocket = ({
  actions,
  classes,
  services,
  activities = [],
  docket,
  width,
  onRefreshActivities,
  onUnaccept,
  selectedTab,
  onChangeTab,
  userProfile,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [noteOptionsAnchor, setNoteOptionsAnchor] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(false);

  /**
   * Returns requested icon
   * @param {string} type Type of icon
   * @returns {React.Component} The component
   */
  const getIcon = (type) => {
    switch (type) {
      case `TRUCK`:
        return <Icons className={classes.icon} type={type} />;
      case `WATCH`:
        return <WatchIcon className={classes.icon} type={type} />;
      case `GRADIENT`:
        return <GradientIcon className={classes.icon} type={type} />;
      case `UNARCHIVE`:
        return <UnarchiveIcon className={classes.icon} type={type} />;
      case `DOMAIN`:
        return <DomainIcon className={classes.icon} type={type} />;
      case `ASSIGNMENT`:
        return <AssignmentIcon className={classes.icon} type={type} />;
      case `WAVES`:
        return <WavesIcon className={classes.icon} type={type} />;
      default:
        return null;
    }
  };

  /**
   * Renders heading
   * @param {Object} heading Heading object to render
   * @returns {React.Component} The rendered heading
   */
  const renderHeading = (heading) => {
    return (
      <Grid alignItems="center" className={classes.heading} container>
        <Grid item>{getIcon(heading.icon)}</Grid>
        <Grid item>
          <Typography className={cn(classes.textTranformUppercase, classes.fontWeight500)} variant="overline">
            {heading.label}
          </Typography>
        </Grid>
        <Grid className={classes.flexGrow1} item>
          {/* information if warning icon should be displayed for this particular row should be send as part of the payload from backend. This way copy changes would not have to be done on both front-end and bacend and front-end would stay responsible only for laying out items as send from server */}
          {heading.label.toLowerCase() === `delivery note` && (
            <Tooltip title="Subject to change where applicable">
              <WarningIcon className={classes.warningIcon} />
            </Tooltip>
          )}
        </Grid>
      </Grid>
    );
  };

  /**
   * Changes tabs
   * @param {string} value Column key
   * @returns {void} void
   */
  const onTabChange = (value) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketModalTabChange`,
          value,
        },
      },
      type: UI_DOCKET_MODAL_TAB_CHANGE,
    });
    setActiveTab(value);
    if (value === 1) {
      onRefreshActivities();
    } else {
      onChangeTab(0);
    }
    return;
  };

  useEffect(() => {
    setActiveTab(selectedTab);
  }, [selectedTab]);

  /**
   * Renders columns
   * @param {Array} columns Array of columns
   * @param {number} key Column key
   * @returns {React.Component} The rendered columns
   */
  const renderColumns = (columns, key) => {
    if (columns[1] === null) {
      return null
    }
    const numberOfColumns = columns.length
    const isSmDown = isWidthDown(`xs`, width)
    const onlyOneColumn = columns.length === 1 // driver instruction only for now as this pattern
    return (
      <Grid className={classes.flexWrapNowrap} container key={key}>
        {columns.map((column, i) => {
          const isLastColumn = i === columns.length - 1 && i !== 0
          // adjust layout based on number of columns as per designers feedback
          let sizing = ''
          if (isSmDown) {
            sizing = {
              className: classes.column,
              xs: 12 / numberOfColumns,
            }
          } else {
            const isSecondColumn = i === 1
            let columnStyle = cn(numberOfColumns > 2 && classes.fixedWidthColumn, classes.flexGrow1)
            if (isSecondColumn) {
              columnStyle = classes.flexGrow2
            }
            sizing = {
              className: cn(classes.column, columnStyle),
            }
          }
          return (
            // we fine to use array index as key in here as these values are static, don't need to nbe reordered and do not have unique ids
            <Grid {...sizing} item key={i}>
              <Typography
                className={cn(
                  !onlyOneColumn ? classes.textTranformUppercase : classes.textTransformNone,
                  classes.rowText,
                  !isLastColumn ? classes.lightText : classes.textAlignRight,
                  classes.fontWeight500,
                )}
                component="div"
                variant="overline"
              >
                {column}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  /**
   * Shows note options
   * @param {Object} e Event triggered
   * @param {Object} activity Activity
   * @returns {void} void
   * @memberof DocketsList
   */
  const showNoteOptions = (e, activity) => {
    setNoteOptionsAnchor(e.currentTarget);
    setSelectedNote(activity);
    return;
  };

  /**
   * Shows delete confirmation modal} void
   * @returns {void} void
   * @memberof DocketsList
   */
  const showDeleteNoteConfirmation = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketModalShowDeleteConfirm`,
        },
      },
      type: UI_DOCKET_MODAL_SHOW_DELETE_CONFIRM,
    });
    setNoteOptionsAnchor(null);
    setDeleteConfirmationModal(true);
    return;
  };

  /**
   * Deletes note
   * @returns {void} void
   * @memberof DocketsList
   */
  const deleteNote = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketModalDeleteNoteAttempt`,
        },
      },
      type: UI_DOCKET_MODAL_DELETE_NOTE_ATTEMPT,
    });
    setIsDeleting(true);
    try {
      const date = dateOnly(docket.ticketDate, ORDER_API_DATE_FORMAT);
      const orderCode = docket.orderCode.trim();
      const docketNumber = docket.docketNumber.trim();
      const docketId = `${date}-${orderCode}-${docketNumber}`;
      setIsDeleting(true);
      await services.docketService.deleteNote({ docketId, noteId: selectedNote.note.id });
      setIsDeleting(false);
      setError(false);
      onRefreshActivities();
    } catch (ex) {
      setIsDeleting(false);
      setError(true);
    }
    setDeleteConfirmationModal(false);
    return;
  };

  /**
   * Renders group that is one level deep in a row
   * @param {Object} group Group to be rendered
   * @param {number} key Column key
   * @returns {React.Component} The rendered group
   */
  const renderGroup = (group, key) => {
    return (
      <Grid container key={key}>
        <Grid className={classes.heading} item xs={12}>
          <Typography className={cn(classes.textTranformUppercase, classes.fontWeight500)} variant="overline">
            {group.label}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {group.rows.map((row, i) => {
            return renderColumns(row, i);
          })}
        </Grid>
      </Grid>
    );
  };

  /**
   * Renders rows
   * @param {Array} rows Array of rows
   * @returns {Array} The rendered array
   */
  const renderRows = (rows) => {
    return rows.map((row, i) => {
      return Array.isArray(row) ? renderColumns(row, i) : renderGroup(row, i);
    });
  };

  /**
   * Check if user is note author
   * @param {string} authorId Author id
   * @returns {boolean} boolean
   */
  const noteAuthor = (authorId) => {
    const { id } = userProfile;
    return id === authorId;
  };

  /**
   * Renders activity
   * @param {Object} activity activity
   * @returns {React.Component} The rendered activity
   */
  const renderActivities = (activity) => {
    let icon = null;
    let action = null;
    let content = null;
    switch (activity.type) {
      case `NOTE_ADDED`: {
        icon = <ModeCommentIcon />;
        action = `Note was added`;
        content = <Typography variant="body1">{activity.note.text}</Typography>;
        break;
      }
      case `DOCKET_VIEWED`: {
        icon = <VisibilityIcon />;
        action = `Docket was viewed`;
        break;
      }
      case `DOCKET_ACCEPTED`: {
        icon = <PlaylistAddCheckIcon />;
        action = `Docket was accepted`;
        break;
      }
      case `DOCKET_UNACCEPTED`: {
        icon = <UndoIcon />;
        action = `Accept undone`;
        break;
      }
      default: {
        icon = null;
      }
    }
    return (
      <ListItem key={generateHash(activity)} alignItems="flex-start">
        <ListItemIcon className={activity.isHighlighted ? classes.highlighted : classes.activityIcon}>{icon}</ListItemIcon>
        <ListItemText
          className={classes.activity}
          primary={
            <React.Fragment>
              <Typography className={content ? classes.activityDateType : ``} variant="body1" data-mf-replace-inner={MFSDR}>
                {`${action} by ${activity.firstName} ${activity.lastName}`}
              </Typography>
              {content}
            </React.Fragment>
          }
          secondary={
            <React.Fragment>
              <Typography className={cn(classes.marginBottom2unit, classes.activityDateType)} variant="caption">
                {activity.type === `DOCKET_VIEWED` ? `First viewed ` : ``}
                {moment(activity.createdDate).format(`ddd DD MMM YYYY h:mma`)}
              </Typography>
            </React.Fragment>
          }
        />
        {activity.type === `NOTE_ADDED` && noteAuthor(activity.userId) && (
          <IconButton className={classes.kebabButton} edge="end" aria-label="More options" onClick={(e) => showNoteOptions(e, activity)}>
            <MoreVertIcon />
          </IconButton>
        )}
      </ListItem>
    );
  };

  /**
   * Renders docket status
   * @param {string} status status
   * @returns {React.Component} The component
   */
  const docketStatus = (status) => {
    switch (status) {
      case `IN_PROGRESS`:
        return (
          <Tooltip title="Docket is in progress and may continue to be updated">
            <Chip className={classes.docketInProgress} label="In Progress" />
          </Tooltip>
        );
      case `COMPLETE`:
        return (
          <Tooltip title="Docket information is complete and no changes will occur">
            <Chip className={classes.docketComplete} label="Completed" />
          </Tooltip>
        );
      default:
        return null;
    }
  };

  /**
   * Hides note options
   * @returns {void} void
   * @memberof DocketsList
   */
  const hideNoteOptions = () => {
    setNoteOptionsAnchor(false);
    return;
  };

  /**
   * Hides delete confirmation modal
   * @returns {void} void
   * @memberof DocketsList
   */
  const onCloseDeleteConfirmationModal = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketModalCancelDeleteNote`,
        },
      },
      type: UI_DOCKET_MODAL_CANCEL_DELETE_NOTE,
    });
    setDeleteConfirmationModal(false);
    return;
  };

  /**
   * Renders tab content
   * @param {number} index tab index
   * @returns {React.Component} react component
   */
  const renderTabContent = (index) => {
    if (index === 0) {
      return docket.values.map((el, i) => (
        <Grid container key={i} spacing={1} data-mf-replace-inner={MFSDR}>
          <Grid item xs={12}>
            {renderHeading(el)}
          </Grid>
          <Grid item xs={12}>
            <Grid className={el.rows[0].constructor === Object ? classes.group : ``} container>
              {renderRows(el.rows)}
            </Grid>
          </Grid>
        </Grid>
      ));
    }
    if (index === 1) {
      // render activity
      return size(activities) === 0 ? <Spinner /> : <List>{activities.map((a) => renderActivities(a))}</List>;
    }
    return null;
  };

  let content = null;

  if (!docket || !docket.values || Object.keys(docket).length === 0) {
    content = <Spinner />;
  } else if (docket.error) {
    content = <Typography variant="body1">Something went wrong fetching docket</Typography>;
  } else {
    content = (
      <React.Fragment>
        <Snackbar
          action={[
            <IconButton aria-label="Close" className={classes.close} color="inherit" key="close" onClick={() => setError(false)}>
              <CloseIcon />
            </IconButton>,
          ]}
          anchorOrigin={{
            horizontal: `left`,
            vertical: `bottom`,
          }}
          className={classes.snackbar}
          ContentProps={{ classes: { root: classes.error } }}
          message={
            <span className={classes.snackbarMessage} id="client-snackbar">
              <ErrorIcon className={classes.snackbarIcon} />
              An error has occurred. Please try again later.
            </span>
          }
          open={!!error}
        />
        <Grid container data-id="deliveryDocketModal">
          <Grid item xs={12}>
            <Typography className={classes.lightText} variant="overline">
              LAST UPDATED {moment(docket.lastUpdated).format(`hh:mma, ddd DD MMM YYYY`)}
            </Typography>
            <Tabs indicatorColor="primary" onChange={(event, value) => onTabChange(value)} textColor="primary" value={activeTab} variant="fullWidth">
              <Tab label="Docket" />
              <Tab label="Activity" />
            </Tabs>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={classes.marginTop1unit}>
          {docket.accepted && (
            <Grid item>
              <Chip variant="outlined" onClick={onUnaccept} color="primary" label="Accepted" icon={<PlaylistAddCheckIcon />} />
            </Grid>
          )}
          <Grid item>{docketStatus(docket.status)}</Grid>
        </Grid>

        {noteOptionsAnchor && (
          <Menu anchorEl={noteOptionsAnchor} onClose={hideNoteOptions} open={!!noteOptionsAnchor}>
            <MenuItem onClick={showDeleteNoteConfirmation}>Delete this</MenuItem>
          </Menu>
        )}
        <Modal
          paperClasses={classes.paperClasses}
          content={<span variant="body2">You cannot undo this.</span>}
          footer={
            isDeleting ? (
              <Grid container justify="flex-end">
                <Grid item>
                  <Spinner size={20} loaderStyles={classes.spinner} />
                </Grid>
              </Grid>
            ) : (
              <Grid className={classes.textAlignRight} container justify="flex-end" spacing={2}>
                <Grid item>
                  <Button onClick={deleteNote} className={classes.button} color="primary" variant="contained">
                    Delete
                  </Button>
                </Grid>
                <Grid item>
                  <Button className={classes.button} color="primary" disabled={isDeleting} onClick={onCloseDeleteConfirmationModal} variant="outlined">
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            )
          }
          onClose={onCloseDeleteConfirmationModal}
          open={!!deleteConfirmationModal}
          maxWidth="sm"
          title={
            <Grid container>
              <Grid item xs={12}>
                Are you sure you want to delete this note?
              </Grid>
            </Grid>
          }
        />
        {/* we fine to use array index as key in here as these values are static, don't need to nbe reordered and do not have unique ids */}
        {renderTabContent(activeTab)}
        <Grid className={classes.marginTop1unit} alignItems="center" container>
          <Grid item>
            <LinkIcon className={cn(classes.nakedIcon)} />
          </Grid>
          <Grid item xs={8}>
            <a className={classes.hyperlink} href={REACT_APP_BORAL_ABRIDGED_CONDITIONS_URL} rel="noopener noreferrer" target="_blank">
              <Typography variant="caption">Abridged Conditions of Quotation and Supply - Concrete</Typography>
            </a>
          </Grid>
        </Grid>
        <Grid className={classes.disclaimer} alignItems="center" container spacing={2}>
          <Grid item>
            <Disclaimer />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
  return content;
};

DeliveryDocket.propTypes = DeliveryDocketPropTypes;

export default compose(
  withWidth(),
  withServices,
  connect(
    (state) => ({
      userProfile: userProfileCurrentSelector(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(deliveryDocketStyles), { withTheme: true }),
)(DeliveryDocket);
